<template>
    <section class="section-wrapper skills-wrapper" id="skills">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="section-title">
                <h2>Skills</h2>
              </div>
            </div>
          </div>
          <!-- .row -->
        <TechSkills />
        <hr />
        <CommunicationSkills />
        <hr />
        <LanguajeSkills />
        <!--.row-->
      </div>
      <!-- .container-fluid -->
    </section>
    <!-- .skills-wrapper -->
</template>

<script>

import TechSkills from './skills/tech-skills.vue'
import LanguajeSkills from './skills/languaje-skills.vue'
import CommunicationSkills from './skills/communication-skills.vue'

export default {
  components: {
    TechSkills,
    LanguajeSkills,
    CommunicationSkills
  }
}
</script>
